import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useRemoveUserFromMatters = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ userId, matterIds }: { userId: string; matterIds: string[] }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          userId: userId,
          matterIds: matterIds,
        },
      });
      await fetch(`${APIBaseChronos}/api/matters/remove-user`, fetchConfig);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.Users, []]);
        toast.success('User removed from matter');
      },
    },
  );
};
